<div id="video-overlay" class="video-overlay" (click)="utilsService.closeVideo()">
  <a class="video-overlay-close" (click)="utilsService.closeVideo()">×</a>
</div>
